import * as i0 from '@angular/core';
import { Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/material/select';

class FsSelectDirective {
    constructor(select) {
        this.select = select;
    }
    ngOnInit() {
        this.select.panelClass = 'fs-select-panel';
    }
}
FsSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectDirective, deps: [{ token: i1.MatSelect }], target: i0.ɵɵFactoryTarget.Directive });
FsSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsSelectDirective, selector: "[fsSelect]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsSelect]',
                }]
        }], ctorParameters: function () { return [{ type: i1.MatSelect }]; } });

class FsSelectModule {
}
FsSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectModule, declarations: [FsSelectDirective], exports: [FsSelectDirective] });
FsSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [
                        FsSelectDirective
                    ],
                    declarations: [
                        FsSelectDirective
                    ],
                }]
        }] });

// Modules

/**
 * Generated bundle index. Do not edit.
 */

export { FsSelectDirective, FsSelectModule };
